export enum RoutePaths {
    HOME = '/',
    LOGIN = '/login',
    SELECT_CONGREGATION = '/menu-congregaciones',
    DASHBOARD = '/dashboard',
    ESTUDIANTES = '/estudiantes',
    USUARIOS = '/usuarios',
    CONFIGURACION = '/configuracion',
    CONGREGACIONES = '/congregaciones',
    PROGRAMA = '/programa',
}
